let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("alVwE")).then(() => parcelRequire('6HtX7'));